import { ReportConfig } from "../definitions";

const branchMonthlyBreakdownReport: ReportConfig = {
  id: "branchMonthlyBreakdownReport",
  name: "Branch Monthly Breakdown Report",
  options: [],
  config: {
    repeat: { name: "month", min: 1, max: 12, step: 1 },
  },
  layout: [
    {
      items: [
        {
          id: "h1",
          title: "",
          widgetType: "figure",
          dataSource: {
            sql: `
            declare @cy int = YEAR(GETDATE());
            declare @startDate date = DATEFROMPARTS(@cy, @month, 1);
            declare @endDate date = EOMONTH(@startDate);

            SELECT
              FORMAT(@startDate, 'MMMM') + ' ' + CAST(@cy AS VARCHAR) AS MonthYear, @endDate
            `,
            returnType: "scalar",
            returnExpression: "0.MonthYear",
          },
          options: { swapTitleAndFigure: true },
        },
      ],
    },
    {
      items: [
        {
          id: "quotes",
          title: "Quotes",
          widgetType: "table",
          columns: [
            { name: "Type", type: "string" },
            { name: "Count", type: "number", align: "right" },
            { name: "Premium", type: "currency", align: "right" },
          ],
          dataSource: {
            sql: `
declare @cy int = YEAR(GETDATE());
declare @startDate date = DATEFROMPARTS(@cy, @month, 1);
declare @endDate date = EOMONTH(@startDate);

SELECT
    [pt].[Type],
    COUNT(*) AS NumberOfQuotes,
    SUM(ISNULL([pa].[APAmount], 0)) AS SumOfPremiumAmounts
FROM
  [dbo].[Proposal] AS [p]
  INNER JOIN [dbo].[ProductType] as [pt] ON [p].[ProductTypeID] = [pt].ID
  INNER JOIN [dbo].[ProposalGroup] AS [pg] ON [p].[ProposalGroupID] = [pg].[ID]
  INNER JOIN [dbo].[Broker] AS [b] ON [pg].[BrokerID] = [b].[ID]

    OUTER APPLY (
        SELECT TOP 1 APAmount
        FROM [dbo].[ProposalClassification] as [pc]
            LEFT JOIN dbo.ProposalAnalyzer as [pa] ON [pa].[ID] = [pc].[ProposalAnalyzerID]
        WHERE [pc].[ProposalID] = [p].ID
        ORDER BY [pa].[ID]) as pa
WHERE
    [p].[CreatedDate] BETWEEN @startDate AND @endDate
    AND [p].[IsDeleted] = 0
    AND (@_branch = 0 OR [b].BranchTypeID = @_branch)
GROUP BY [pt].[Type]
ORDER BY SUM([pa].[APAmount]) DESC
`,
            returnType: "table",
          },
        },
        {
          id: "written",
          title: "Written Applications",
          widgetType: "table",
          columns: [
            { name: "Type", type: "string" },
            { name: "Count", type: "number", align: "right" },
            { name: "Premium", type: "currency", align: "right" },
          ],
          dataSource: {
            sql: `
declare @cy int = YEAR(GETDATE());
declare @startDate date = DATEFROMPARTS(@cy, @month, 1);
declare @endDate date = EOMONTH(@startDate);

SELECT
    [c].[Type],
    COUNT(*) AS ApplicationsWritten,
    SUM([ap].[AnnualizedPremium]) AS TotalPremiumWritten
FROM [awu].[Application] [a]
    LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    LEFT JOIN [dbo].[CarrierType] [c] ON [a].[CarrierID] = [c].[ID]
WHERE
    [a].[EntryDate] BETWEEN @startDate and @endDate
    AND ([a].IsDeleted = 0 OR [a].IsDeleted IS NULL)
    AND st.[ScenarioTypeCode] = 'F'
    AND (@_branch = 0 OR [a].BranchTypeID = @_branch)
GROUP BY [c].[Type]
ORDER BY TotalPremiumWritten DESC

`,
            returnType: "table",
          },
        },
        {
          id: "paid",
          title: "Paid Applications",
          widgetType: "table",
          columns: [
            { name: "Type", type: "string" },
            { name: "Count", type: "number", align: "right" },
            { name: "Premium", type: "currency", align: "right" },
          ],
          dataSource: {
            sql: `
declare @cy int = YEAR(GETDATE());
declare @startDate date = DATEFROMPARTS(@cy, @month, 1);
declare @endDate date = EOMONTH(@startDate);

SELECT
    [c].[Type],
    COUNT(*) AS ApplicationsWritten,
    SUM([ap].[AnnualizedPremium]) AS TotalPremiumWritten
FROM [awu].[Application] [a]
    LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    LEFT JOIN [dbo].[CarrierType] [c] ON [a].[CarrierID] = [c].[ID]
WHERE
    ([a].IsDeleted = 0 OR [a].IsDeleted IS NULL)
    AND [a].[PaidOrClosedDate] BETWEEN @startDate and @endDate
    AND st.[ApplicationStatusCode] in ('2', '3', 'P')
    AND st.[ScenarioTypeCode] = 'F'
    AND (@_branch = 0 OR [a].BranchTypeID = @_branch)
GROUP BY [c].[Type]
ORDER BY TotalPremiumWritten DESC

`,
            returnType: "table",
          },
        },
      ],
    },
    {
      items: [
        {
          id: "quotes-pie",
          title: "",
          widgetType: "pie",
          dataSource: {
            sql: `
declare @cy int = YEAR(GETDATE());
declare @startDate date = DATEFROMPARTS(@cy, @month, 1);
declare @endDate date = EOMONTH(@startDate);

SELECT
    [pt].[Type],
    SUM(ISNULL([pa].[APAmount], 0)) AS SumOfPremiumAmounts
FROM
  [dbo].[Proposal] AS [p]
  INNER JOIN [dbo].[ProductType] as [pt] ON [p].[ProductTypeID] = [pt].ID
    OUTER APPLY (
        SELECT TOP 1 APAmount
        FROM [dbo].[ProposalClassification] as [pc]
            LEFT JOIN dbo.ProposalAnalyzer as [pa] ON [pa].[ID] = [pc].[ProposalAnalyzerID]
        WHERE [pc].[ProposalID] = [p].ID
        ORDER BY [pa].[ID]) as pa
WHERE
    [p].[CreatedDate] BETWEEN @startDate AND @endDate AND [p].[IsDeleted] = 0
GROUP BY [pt].[Type]
ORDER BY SUM([pa].[APAmount]) DESC
`,
            returnType: "table",
          },
        },
        {
          id: "written-pie",
          title: "",
          widgetType: "pie",
          dataSource: {
            sql: `
declare @cy int = YEAR(GETDATE());
declare @startDate date = DATEFROMPARTS(@cy, @month, 1);
declare @endDate date = EOMONTH(@startDate);

SELECT
    [c].[Type],
    SUM([ap].[AnnualizedPremium]) AS TotalPremiumWritten
FROM [awu].[Application] [a]
    LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    LEFT JOIN [dbo].[CarrierType] [c] ON [a].[CarrierID] = [c].[ID]
WHERE
    [a].[EntryDate] BETWEEN @startDate and @endDate
    AND ([a].IsDeleted = 0 OR [a].IsDeleted IS NULL)
    AND st.[ScenarioTypeCode] = 'F'
    AND (@_branch = 0 OR [a].BranchTypeID = @_branch)
GROUP BY [c].[Type]
ORDER BY TotalPremiumWritten DESC

`,
            returnType: "table",
          },
        },
        {
          id: "paid-pie",
          title: "",
          widgetType: "pie",
          dataSource: {
            sql: `
declare @cy int = YEAR(GETDATE());
declare @startDate date = DATEFROMPARTS(@cy, @month, 1);
declare @endDate date = EOMONTH(@startDate);

SELECT
    [c].[Type],
    SUM([ap].[AnnualizedPremium]) AS TotalPremiumWritten
FROM [awu].[Application] [a]
    LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    LEFT JOIN [dbo].[CarrierType] [c] ON [a].[CarrierID] = [c].[ID]
WHERE
    ([a].IsDeleted = 0 OR [a].IsDeleted IS NULL)
    AND [a].[PaidOrClosedDate] BETWEEN @startDate and @endDate
    AND st.[ApplicationStatusCode] in ('2', '3', 'P')
    AND st.[ScenarioTypeCode] = 'F'
    AND (@_branch = 0 OR [a].BranchTypeID = @_branch)
GROUP BY [c].[Type]
ORDER BY TotalPremiumWritten DESC
`,
            returnType: "table",
          },
        },
      ],
    },
  ],
};

export default branchMonthlyBreakdownReport;
